import { SideNavItem } from "@design-system/SideNav/SideNavItem";
import { SideNavSection } from "@design-system/SideNav/SideNavSection";
import { SideNavSubItem } from "@design-system/SideNav/SideNavSubItem";
import { useIsGlFirst } from "@hooks/useIsGlFirst";
import {
    AccountsIcon,
    FolderIcon,
    OwnershipIcon,
    TransactionsIcon,
} from "@icons";
import { getActionsTasksAccountsNavPaths } from "../getActionsTasksAccountsNavPaths";
import { useNavigationShortcutKeys } from "./useNavigationShortcutKeys";
import { useRouteExpansion } from "./useRouteExpansion";
import type { SideNavSectionState } from "./sideNavSection.types";

const TransactionsRow = () => {
    const { enabled: isGlFirst } = useIsGlFirst();
    const shortcutKeys = useNavigationShortcutKeys();
    const expansion = useRouteExpansion({
        parentPath: "/transactions",
        subItemPaths: ["/categories"],
    });

    if (isGlFirst) {
        return (
            <SideNavItem
                to="/transactions"
                end
                icon={<TransactionsIcon />}
                label="Transactions"
                shortcut={shortcutKeys("/transactions")}
            />
        );
    }

    return (
        <SideNavItem
            to="/transactions"
            end
            icon={<TransactionsIcon />}
            label="Transactions"
            shortcut={shortcutKeys("/transactions")}
            {...expansion}
        >
            <SideNavSubItem to="/categories" end label="Categories" />
        </SideNavItem>
    );
};

/** Accounts, Transactions, Documents and, with consolidation, Ownership. */
export const DataSection = ({
    section,
    canUseConsolidation,
    hasBusinessEntities,
}: {
    section: SideNavSectionState;
    canUseConsolidation: boolean;
    hasBusinessEntities: boolean;
}) => {
    const { accountsTabPath } = getActionsTasksAccountsNavPaths();
    const shortcutKeys = useNavigationShortcutKeys();
    const documentsExpansion = useRouteExpansion({
        parentPath: "/documents",
        subItemPaths: ["/document-categories"],
    });

    return (
        <SideNavSection {...section}>
            <SideNavItem
                to={accountsTabPath}
                icon={<AccountsIcon />}
                label="Accounts"
                shortcut={shortcutKeys(accountsTabPath)}
            />
            <TransactionsRow />
            <SideNavItem
                to="/documents"
                end
                icon={<FolderIcon />}
                label="Documents"
                shortcut={shortcutKeys("/documents")}
                {...documentsExpansion}
            >
                <SideNavSubItem
                    to="/document-categories"
                    end
                    label="Document categories"
                />
            </SideNavItem>
            {canUseConsolidation && hasBusinessEntities && (
                <SideNavItem
                    to="/ownership"
                    end
                    icon={<OwnershipIcon />}
                    label="Ownership"
                />
            )}
        </SideNavSection>
    );
};
